import { BRAND } from "@/lib/constants";

export function BrandHeader({ right, subtitle }) {
  return (
    <header className="border-b border-zinc-800/80 sticky top-0 z-30 backdrop-blur-xl bg-zinc-950/80">
      <div className="max-w-7xl mx-auto px-6 py-3.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-4 min-w-0">
          <img src={BRAND.LOGO_AM} alt="Argentina Mining Norte 2026" className="h-10 w-auto shrink-0" />
          <div className="hidden sm:block h-8 w-px bg-zinc-800" />
          <div className="min-w-0 hidden sm:block">
            <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500">Paquete Full Equipado</div>
            <div className="text-sm font-medium text-white truncate">{subtitle || "Argentina Mining Norte 2026"}</div>
          </div>
        </div>
        <div className="flex items-center gap-4">
          {right}
          <div className="hidden md:flex items-center gap-2 pl-4 border-l border-zinc-800">
            <img src={BRAND.LOGO_SO} alt="Servicios Oficiales" className="h-8 w-auto invert opacity-80" />
          </div>
        </div>
      </div>
    </header>
  );
}

export function BrandFooter() {
  return (
    <footer className="border-t border-zinc-900 mt-16">
      <div className="max-w-7xl mx-auto px-6 py-8 flex flex-wrap gap-6 items-center justify-between">
        <div className="flex items-center gap-6">
          <img src={BRAND.LOGO_AM} alt="Argentina Mining Norte 2026" className="h-8 w-auto opacity-90" />
          <img src={BRAND.LOGO_SO} alt="Servicios Oficiales" className="h-8 w-auto invert opacity-70" />
        </div>
        <div className="text-xs text-zinc-500">
          Configuración y asistencia técnica a cargo de Servicios Oficiales.
        </div>
      </div>
    </footer>
  );
}
